<template>
	<ValidationProvider :name="options.label" :rules="options.rules" v-slot="{ errors }" slim>
		<div class="checkboxElement">
			<div :class="[options.wrapperClass, { disabled: getEventIsInactive(options.id) || options.disabled === true }]">
				<input
					type="checkbox"
					:class="options.className"
					:id="generatedId"
					:value="isCheckedEvent(options.id, options.isTemp)"
					@input="setEvent({ id: options.id, temp: options.isTemp })"
					:checked="isCheckedEvent(options.id, options.isTemp)"
					:disabled="getEventIsInactive(options.id) || options.disabled === true"
					data-hj-allow
				/>
				<span class="chbox_style"></span>
				<span>
					<label :for="generatedId">
						<span v-html="options.label"></span>
						<span
							v-if="options.tooltip"
							v-tooltip="options.tooltipText"
							class="info"
							@click="handleClick"
						></span>
					</label>
					<span
						class="plus-coverage"
						v-if="options.id === 22 && getValuableSum > 200000 && getCategory !== 2"
					>
						Fedezeti összeg: {{ (getValuableSum - 200000) | toCurrency }}
					</span>
				</span>
			</div>
			<span class="error_message error_message--broke">{{ errors[0] }}</span>
		</div>
	</ValidationProvider>
</template>

<script>
import shared from '@/mixins/shared';
import { mapGetters, mapMutations } from 'vuex';

export default {
	mixins: [shared],
	computed: {
		...mapGetters(['isCheckedEvent', 'getEventIsInactive', 'getValuableSum', 'getCategory']),
	},
	methods: {
		...mapMutations(['setEvent']),
		handleClick(e) {
			e.preventDefault();
			e.stopPropagation();
		},
	},
};
</script>

<style lang="scss" scoped>
.plus-coverage {
	font-size: 14px;
	line-height: 16px;
}

.disabled {
	input {
		cursor: none;
		pointer-events: none;
	}

	label {
		color: #ccc;

		span:not(.info) {
			pointer-events: none;
		}
	}

	.chbox_style {
		background-color: #ccc;
	}
}
</style>
